import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import CKEditor from 'ckeditor4-react';
import ReactFileReader from 'react-file-reader';
import NoIMAGE from '../assets/noimage.jpg';
const GLOBAL = require('../Globals');

const styles = {
	imgStyle : {
		padding:'10px',border : '1px solid #d8d8d8',margin : '10px',height : '100px'
	},
	plusImgStyle : {
		padding:'10px',border : '1px solid #d8d8d8',margin : '10px',backgroundColor : '#f1f1f1',cursor : 'pointer'
    },
    btnStyle: {
		position: 'absolute',
		top: '1px',
		right: '2px',
		borderRadius: '10px',
		cursor: 'pointer'
	}
}

class EditQuestion extends Component {
	
	constructor(props){
		super(props);
		this.state = {
            editData : this.props.data,
            imgdata : this.props.img,
			id : this.props.id,
			_message : '',
            alertClass :'',
            btnText : 'Update',
            files : [],
            filesname : [],
            file1 : [],
            file2 : [],
            file3 : [],
            file4 : [],
            removeImage : [],
			_redirect : false
        }
        this.getQusFiles = this.getQusFiles.bind(this);
        this.onChkChange = this.onChkChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
    }

    getQusFiles(files) {
       
        for (var i = 0; i < (files.base64).length; i++) {
            this.state.files.push(files.base64[i]);
            this.state.filesname.push(files.fileList[i].name);
        }
        this.setState({ files: this.state.files,filesname : this.state.filesname });
    }
    
    handleRemove(index) {
		this.state.files.splice(index, 1);
		this.state.filesname.splice(index, 1);
		this.setState({ files: this.state.files,filesname: this.state.filesname });
    }
    
    handleImgRemove(id,index){
        this.state.removeImage.push({"id" : id});
        this.state.imgdata.splice(index, 1);
        this.setState({ imgdata: this.state.imgdata,removeImage : this.state.removeImage});
    }

    getFiles(name,files){
        var fname = name+'name';
		this.setState({[name] : files.base64,[fname] : files.fileList[0].name});
    }

    onChkChange(e){
        var d = this.state.editData;
        if(e.target.checked){
            this.setState({ismath : 1});
            d['ismath'] = 1;
        }
        else{
            this.setState({ismath : 0});
            d['ismath'] = 0;
        }
        this.setState({editData:d});
    }
    
    onEditorChange(name,evt) {
        this.setState({
            [name]: evt.editor.getData()
        });
        var d = this.state.editData;
        d[name] = evt.editor.getData();
        this.setState({editData:d});
    }
	
	onCancelClick(e){
        this.props.cancelClick();
	}
	
	/** set value **/
	setValue(field,e){
        var d = this.state.editData;
        d[field] = e.target.value;
        this.setState({editData:d});
    }
    
    getValue(field){
        var d = this.state.editData;
        return d[field];
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		this.setState({btnText : 'Updating...'})
        PostData('question/editquestion',this.state).then((result) => {
            let responseJson = result;
            if(responseJson.status == '1' ){
                this.setState({
                    _message:'Question Updated Successfully!..',
                    alertClass:'alert alert-success',
                    btnText : 'Update'
                });
                document.getElementById("addqus").reset();
                this.props.afterFinish();
            }
            else{
        
                this.setState({
                    _message:'Invalid Key',
                    alertClass:'alert alert-danger'
                });
            }
        });
	}
	
    render() {
	 
	if(this.state._redirect){
		  
		return (<Redirect to='/timetable/room' />);
	}
	
    return (
        <div>
            <form action="" method="post" role="form" id="addqus" encType="multipart/form-data" onSubmit={this.onSubmit} >
            <Row>
                <div style={{position: 'absolute',top: '-40px',left: '160px'}}>
                    <label class="switch switch-text switch-pill switch-success">
                        <input type="checkbox" class="switch-input" checked={this.getValue('ismath') == 1 ? true : false} onClick={this.onChkChange} />
                        <span class="switch-label" data-on="On" data-off="Off"></span>
                        <span class="switch-handle"></span>
                    </label>&nbsp;
                    <span>Math Editor</span>
                </div>
                <Col md="6">
                    <FormGroup>
                        <Label>Book <span className="text-danger">*</span></Label>
                        <Input type="text" name="book" onChange={this.setValue.bind(this,'book')} value={this.getValue('book')} required />
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Lesson <span className="text-danger">*</span></Label>
                        <Input type="text" name="lesson" onChange={this.setValue.bind(this,'lesson')} value={this.getValue('lesson')} required />
                    </FormGroup>
                </Col>
                <Col md="12">
                    <FormGroup>
                        <Label style={{width : '100%'}}>Question <span className="text-danger">*</span>
                            <span style={{float : 'right'}}>
                                <ReactFileReader fileTypes={[".png", ".jpg", ".jpeg"]} multipleFiles={true} base64={true} handleFiles={this.getQusFiles}>
                                    <Button type="button" color="info" size="sm"><i className="fa fa-plus"></i>&nbsp;Add Image</Button>
                                </ReactFileReader>
                            </span>
                        </Label>
                        {this.getValue('ismath') == 1 ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'question')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.getValue('question')} /> :
                        <textarea name="question" className="form-control" onChange={this.setValue.bind(this,'question')} value={this.getValue('question').replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")} required /> }
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                {this.state.imgdata.map((item, i) => {
                    return (<Col md={2}>
                        <img src={GLOBAL.BASE_URL+item.image} width="100px" style={styles.imgStyle} />
                        <button type="button" className="btn btn-danger btn-sm" style={styles.btnStyle} onClick={this.handleImgRemove.bind(this, item.id, i)}><i className="fa fa-remove"></i></button>
                    </Col>);
                })}
                {this.state.files.map((item, i) => {
                    return (<Col md={2}>
                        <img src={item} width="100px" style={styles.imgStyle} />
                        <button type="button" className="btn btn-danger btn-sm" style={styles.btnStyle} onClick={this.handleRemove.bind(this, i)}><i className="fa fa-remove"></i></button>
                    </Col>);
                })}
            </Row>
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label>Option 1 <span className="text-danger">*</span></Label>
                        {this.getValue('ismath') == 1 ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'option1')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.getValue('option1')} /> :
                        <textarea name="option1" className="form-control" onChange={this.setValue.bind(this,'option1')} value={this.getValue('option1').replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")} required={this.state.file1.length > 0 ? false : (this.getValue('optimage1')!='' && this.getValue('optimage1')!=null) ? false : true} /> }
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Option 2 <span className="text-danger">*</span></Label>
                        {this.getValue('ismath') == 1 ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'option2')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.getValue('option2')} /> :
                        <textarea name="option2" className="form-control" onChange={this.setValue.bind(this,'option2')} value={this.getValue('option2').replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")} required={this.state.file2.length > 0 ? false : (this.getValue('optimage1')!='' && this.getValue('optimage1')!=null) ? false : true} /> }
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Option 3</Label>
                        {this.getValue('ismath') == 1 ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'option3')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.getValue('option3')} /> :
                        <textarea name="option3" className="form-control" onChange={this.setValue.bind(this,'option3')} value={this.getValue('option3').replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")} /> }
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Option 4</Label>
                        {this.getValue('ismath') == 1 ?
                        <CKEditor name='editor' onChange={this.onEditorChange.bind(this,'option4')} config={{ removeButtons : '', extraPlugins: 'mathjax,print,font', mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML', height: 150, height: '150', startupShowBorders: 'false', allowedContent: true, extraAllowedContent: '*(*);*{*}' }} data={this.getValue('option4')} /> :
                        <textarea name="option4" className="form-control" onChange={this.setValue.bind(this,'option4')} value={this.getValue('option4').replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")} /> }
                    </FormGroup>
                </Col>
                <Col md="3">
                    <Label>Option 1 Image</Label>
                    <ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles.bind(this,'file1')}>
                        <img src={this.state.file1.length > 0 ? this.state.file1 : (this.getValue('optimage1')!='' && this.getValue('optimage1')!=null) ? GLOBAL.BASE_URL+this.getValue('optimage1') : NoIMAGE} width="100px" style={styles.plusImgStyle} />
                    </ReactFileReader>
                </Col>
                <Col md="3">
                    <Label>Option 2 Image</Label>
                    <ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles.bind(this,'file2')}>
                        <img src={this.state.file2.length > 0 ? this.state.file2 : (this.getValue('optimage2')!='' && this.getValue('optimage2')!=null) ? GLOBAL.BASE_URL+this.getValue('optimage2') : NoIMAGE} width="100px" style={styles.plusImgStyle} />
                    </ReactFileReader>
                </Col>
                <Col md="3">
                    <Label>Option 3 Image</Label>
                    <ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles.bind(this,'file3')}>
                        <img src={this.state.file3.length > 0 ? this.state.file3 : (this.getValue('optimage3')!='' && this.getValue('optimage3')!=null) ? GLOBAL.BASE_URL+this.getValue('optimage3') : NoIMAGE} width="100px" style={styles.plusImgStyle} />
                    </ReactFileReader>
                </Col>
                <Col md="3">
                    <Label>Option 4 Image</Label>
                    <ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles.bind(this,'file4')}>
                        <img src={this.state.file4.length > 0 ? this.state.file4 : (this.getValue('optimage4')!='' && this.getValue('optimage4')!=null) ? GLOBAL.BASE_URL+this.getValue('optimage4') : NoIMAGE} width="100px" style={styles.plusImgStyle} />
                    </ReactFileReader>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Answer <span className="text-danger">*</span></Label>
                        <select name="answer" class="form-control" onChange={this.setValue.bind(this,'answer')} value={this.getValue('answer')} required>
                            <option value="">Select Answer</option>
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                            <option value="option4">Option 4</option>
                        </select>
                    </FormGroup>
                </Col>
                <Col md="9">
                    <FormGroup>
                        <Label>Explanation</Label>
                        <textarea name="explanation" className="form-control" onChange={this.setValue.bind(this,'explanation')} value={this.getValue('explanation')} />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>Create by</Label>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Input type="text" name="createby" onChange={this.setValue.bind(this,'createby')} value={this.getValue('createby')} />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Button type="submit" color="primary" style={{float : 'right'}} disabled={this.state.btnText == 'Update' ? false : true}>{this.state.btnText}</Button>&emsp;
                        <Button color="danger" style={{float : 'right'}} onClick={this.onCancelClick.bind(this)}>Cancel</Button>&emsp;
                    </FormGroup>
                </Col>
            </Row>
            </form>
        </div>
	);
  }
}

export default EditQuestion;



// WEBPACK FOOTER //
// ./src/Questions/EditQuestion.js